// @ts-nocheck
import React from "react";
import { RotateCw } from "lucide-react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Button,
  showToast,
} from "@/components/ui";
import { SyncStatusBadge } from "./SyncStatusBadge";
import { fmtDate } from "./sellerDetail.utils";

export const SyncTab = ({ d }) => (
  <Card>
    <CardHeader>
      <CardTitle className="text-base">Marketplace Sync History</CardTitle>
    </CardHeader>
    <CardContent className="p-0">
      <table data-testid="sync-table" className="w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 dark:border-slate-700">
            {[
              "Marketplace",
              "Status",
              "Started",
              "Duration",
              "Products",
              "Errors",
              "",
            ].map((h, i) => (
              <th
                key={i}
                className="px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
          {d.syncLogs.map((log) => (
            <tr
              key={log.id}
              data-testid={`sync-row-${log.id}`}
              className="hover:bg-slate-50 dark:hover:bg-slate-800/50"
            >
              <td className="px-4 py-2.5 font-medium text-slate-900 dark:text-slate-100">
                {log.marketplace}
              </td>
              <td className="px-4 py-2.5">
                <SyncStatusBadge status={log.status} />
              </td>
              <td className="px-4 py-2.5 text-xs text-slate-500 dark:text-slate-400">
                {fmtDate(log.startedAt)}
              </td>
              <td className="px-4 py-2.5 text-slate-700 dark:text-slate-300">
                {log.duration}
              </td>
              <td className="px-4 py-2.5 text-slate-700 dark:text-slate-300">
                {log.products.toLocaleString()}
              </td>
              <td className="px-4 py-2.5">
                {log.errors > 0 ? (
                  <span className="text-rose-600 dark:text-rose-400 font-medium">
                    {log.errors}
                  </span>
                ) : (
                  <span className="text-slate-400">0</span>
                )}
              </td>
              <td className="px-4 py-2.5">
                {log.status === "FAILED" && (
                  <Button
                    variant="outline"
                    size="sm"
                    data-testid={`retry-sync-${log.id}`}
                    onClick={() =>
                      showToast.info(
                        "Retry",
                        `Retrying ${log.marketplace} sync...`,
                      )
                    }
                  >
                    <RotateCw className="w-3.5 h-3.5" /> Retry
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </CardContent>
  </Card>
);
